import React, {useState} from 'react'
import GenericAuthentication, {} from './GenericAuthentication'






const InvitationLinkAuthentication = (props) => {
  const [page, setPage] = useState('create-account')
  const goToPage = (page) => {
    setPage(page)
  }
  return React.createElement(GenericAuthentication, { ...props, goToPage: goToPage, page: page,} )
}

export default InvitationLinkAuthentication
